const scheduler: Permission = {
  order: 3,
  label: 'Scheduler',
  rules: {
    dashboard: { view: true, edit: true, viewOwnTeamOnly: true, viewSubPage: true },
    documents: { view: true, create: true, edit: true, delete: false },
    timeline: { view: true, create: true, viewOwnTeamOnly: false, edit: true, delete: true, restore: false, permanentDelete: false },
    dailyLog: {
      view: true,
      create: true,
      edit: true,
      delete: true,
      restore: false,
      permanentDelete: false,
      viewSubPage: false,
      previousStatus: false,
      sendSMS: true,
      documents: { view: true, create: true, edit: true, delete: true }
    },
    priceAnalysis: { view: true, edit: true },
    map: { view: true },
    projectPage: { view: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    projectList: { view: true, viewSameOrganizationOnly: false, create: true, edit: true, delete: false, restore: false, permanentDelete: false, viewSubPage: false },
    projectDescription: { view: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    projectAnalysis: { view: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    report: { view: false, viewSelfOnly: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    organizations: { view: true, create: true, edit: true, delete: true, restore: false, permanentDelete: false, viewSubPage: false },
    organizationPage: { view: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false },
    activities: { view: true, create: true, edit: true, delete: true, restore: false, permanentDelete: false, editActivityPriceType: false },
    materials: { view: true, create: true, edit: true, delete: true, restore: false, permanentDelete: false },
    equipments: { view: true, create: true, edit: true, delete: true, restore: false, permanentDelete: false },
    employees: { view: true, create: true, edit: true, delete: true, restore: false, permanentDelete: false },
    teams: { view: true, create: true, edit: true, delete: true, restore: false, permanentDelete: false },
    administration: { view: false, create: false, edit: false, delete: false, restore: false, permanentDelete: false }
  },
  value: 'scheduler'
};

export default scheduler;
